import DashboardIcon from "../assets/images/app/allaya/sidebar-icons/dashboard.svg";
import GuestUsersIcon from "../assets/images/app/allaya/sidebar-icons/users.svg";
import AudioIcon from "../assets/images/app/allaya/sidebar-icons/headphone-icon.svg";
import NotificationIcon from "../assets/images/app/allaya/sidebar-icons/notification.svg";
import GoalIcon from "../assets/images/app/allaya/sidebar-icons/goal-icon.svg";
import AuthorNarratorIcon from "../assets/images/app/allaya/sidebar-icons/author-narrator-icon.svg";
import PromoIcon from "../assets/images/app/allaya/sidebar-icons/promo-icon.svg";
import SettingsIcon from "../assets/images/app/allaya/sidebar-icons/account.svg";

import { Roles } from "../constants";
import { APP_ROUTES } from "../helpers/routeHelpers";

let { Admin, SuperAdmin } = Roles;

const SIDEBAR_CONFIG = [
    {
        title: "Dashboard",
        url: APP_ROUTES.DASHBOARD,
        icon: null,
        menuImg: DashboardIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "User Management",
        url: APP_ROUTES.USER_MANAGEMENT,
        icon: null,
        menuImg: GuestUsersIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "Audio Content Management",
        url: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT,
        icon: null,
        menuImg: AudioIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "Notification Management",
        url: APP_ROUTES.NOTIFICATION_MANAGEMENT,
        icon: null,
        menuImg: NotificationIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "Goal Management",
        url: APP_ROUTES.GOAL_MANAGEMENT,
        icon: null,
        menuImg: GoalIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "Author & Narrator Management",
        url: APP_ROUTES.AUTHOR_AND_NARRATOR_MANAGEMENT,
        icon: null,
        menuImg: AuthorNarratorIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    // {
    //     title: "Promo Codes",
    //     url: APP_ROUTES.JOB_LISTING,
    //     icon: null,
    //     menuImg: PromoIcon,
    //     nestedMenu: null,
    //     permissions: [Admin]
    // },
    {
        title: "Profile",
        url: APP_ROUTES.ACCOUNT,
        icon: null,
        menuImg: SettingsIcon,
        nestedMenu: null,
        permissions: [Admin]
    }
];

export default SIDEBAR_CONFIG;
